import { getSettingsRemote } from '@portal/actions/onboarding';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AdvancedCheckbox from '../AdvancedCheckbox/AdvancedCheckbox';

interface IProps {
  value: boolean;
  url: string;
  title: string;
  checkboxLabel: string;
  onChange: (value: boolean) => void;
}

const TermsAndPrivacy = ({
  title,
  checkboxLabel,
  value,
  onChange,
  url,
}: IProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettingsRemote());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="terms-of-use">
      <p className="terms-of-use__text">{title}</p>
      <iframe src={`${url}#toolbar=0`} width="90%" height={400} />
      <div className="terms-of-use__checkbox">
        <AdvancedCheckbox
          label={checkboxLabel}
          value={value}
          onChange={(value) => onChange(value)}
        />
      </div>
    </div>
  );
};

export default TermsAndPrivacy;
